import React from "react";
import { Typewriter } from "react-simple-typewriter";
import "./home.scss";
import { motion } from "framer-motion";
const Home = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ type: "tween", duration: 0.5 }}
      className="home"
    >
      <div className="wrapper">
        <div className="left">
          <h1>
            ADRIANO <span>SMITH</span>
          </h1>
          <p>
            <Typewriter
              words={["Developer", "Designer", "Photographer"]}
              loop={Infinity}
              cursor
              cursorStyle="|"
              typeSpeed={70}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </p>
        </div>
        <div className="right">
          <img
            src="https://res.cloudinary.com/raiusl/image/upload/v1687873881/arun-sharma-UmmnAirqX4o-unsplash_1_r3naws.jpg"
            alt=""
          />

          <div className="overlay"></div>
        </div>
      </div>
    </motion.div>
  );
};

export default Home;
